module.exports = __webpack_public_path__ + "static/media/pokloni-za-sve.6ee16095.png";